import { render, staticRenderFns } from "./AssistantStep.vue?vue&type=template&id=fa0a7c74"
import script from "./AssistantStep.vue?vue&type=script&lang=ts"
export * from "./AssistantStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports